import { AppBar, Box, Button, Container, Toolbar, Typography } from '@mui/material';
import { Outlet, Navigate, useNavigate } from 'react-router-dom';
import { LoadingContent } from '../../components/Loading';
import { useAuth } from '../../context/AuthContext';
import {
    getStoredAdvertiser,
    getStoredUser,
    isAdvertiserUser,
    isAdvertiserContractSigned,
} from '../../services/authSession';
import Logo from '../../assets/logo.png';
import { advertiserLayoutSx } from './advertiserLayoutSx';

/**
 * Shell mínimo para o fluxo de assinatura: autenticado, sem menu e sem tutorial.
 * Anunciante já aprovado ou com contrato assinado volta para o painel.
 */
export default function AdvertiserContractShell() {
    const navigate = useNavigate();
    const advertiser = getStoredAdvertiser();
    const { authenticated, authReady, user, LogOut } = useAuth();
    const sessionUser = user || getStoredUser();

    if (!authReady || (authenticated && !sessionUser)) {
        return <LoadingContent />;
    }

    if (!authenticated) {
        return <Navigate to="/anunciante/login" replace />;
    }

    if (!isAdvertiserUser(sessionUser)) {
        return <Navigate to="/anunciante/login" replace />;
    }

    if (isAdvertiserContractSigned(advertiser)) {
        return <Navigate to="/anunciante" replace />;
    }

    return (
        <Box minHeight="100vh" display="flex" flexDirection="column" bgcolor="grey.50">
            <AppBar position="sticky" elevation={0} color="inherit" sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Toolbar sx={{ gap: 2 }}>
                    <Box component="img" src={Logo} width={140} alt="Eurobem" />
                    <Typography variant="subtitle1" fontWeight="bold" color="text.primary">
                        Assinatura do contrato
                    </Typography>
                    <Box flexGrow={1} />
                    <Typography variant="body2" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
                        {advertiser?.name || sessionUser?.userName}
                    </Typography>
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {
                            LogOut('/anunciante');
                            navigate('/anunciante/login', { replace: true });
                        }}
                    >
                        Sair
                    </Button>
                </Toolbar>
            </AppBar>
            <Container maxWidth="md" sx={{ py: 4, flex: 1, ...advertiserLayoutSx }}>
                <Outlet />
            </Container>
        </Box>
    );
}
